import React from "react";
import PropTypes from "prop-types";
import TestItem from "../TestItem";
import { Divider } from "@material-ui/core";
import TestItemHorizontal from "../TestItemHorizontal";
import { Table } from "reactstrap";
import { Link } from "react-router-dom";
import AccessTimeOutlined from "@material-ui/icons/AccessTimeOutlined";

const TestsList = ({ items }) => {
  return (
    <Table striped>
      {Array.isArray(items) && (
        <tbody>
          {items.map((item, index) => (
            <tr key={`item_${item.id}`}>
              <td>{item.title}</td>
              <td>
                <img
                  className={"test-item-horizontal-img"}
                  src={
                    item.attachment &&
                    `${process.env.REACT_APP_API_URL_BO}private/${item.attachment.name}`
                  }
                />
              </td>
              <td>
                <div className={"test-item-horizontal-project-type"}>
                  <Link to={`/test/${item.id}/detail`}>
                    {item.project.project_type &&
                      item.project.project_type.name}
                  </Link>
                </div>
              </td>
              <td>
                {Array.isArray(item.project.medical_visits) &&
                  item.project.medical_visits[0] && (
                    <span>
                      <AccessTimeOutlined /> Día inicio{" "}
                      {item.project.medical_visits[0].date}
                    </span>
                  )}
              </td>
              <td>
                {Array.isArray(item.project.medical_visits) &&
                  item.project.medical_visits[1] && (
                    <span>
                      <AccessTimeOutlined /> Día fin{" "}
                      {item.project.medical_visits[1].date}
                    </span>
                  )}
              </td>
            </tr>
          ))}
        </tbody>
      )}
    </Table>
  );
  return (
    <React.Fragment>
      {items.map(item => (
        <React.Fragment key={item.id}>
          <TestItemHorizontal testItem={item} />
          <Divider />
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

TestsList.propTypes = {
  items: PropTypes.array.isRequired
};

export default TestsList;



// WEBPACK FOOTER //
// ./src/modules/test/components/TestsList/tests-list.js